export function getRegistrationInvestorCategory () {
  return [
    { name: 'Individual', value: 'INDV'},
    { name: 'Corporation', value: 'CORP'}
  ]
}

export function getOrganizationType () {
  return [
    { name: 'Partnership of Other Juridical Entry', value: 'PARTNERSHIP'},
    { name: 'Investment House', value: 'INVESTMENT'},
    { name: 'Bank', value: 'BANK'},
    { name: 'Insurance Company', value: 'INSURANCE'},
    { name: 'Corporation', value: 'CORP'},
    { name: 'Incorporated Mutual Fund', value: 'INCORP'},
    { name: 'Trust Company/Trust Fund/Trust', value: 'TRUST'}
  ]
}
